const distanceNature = [
  {
    key: 0,
    value: "Distances",
    check: true,
    swim: "Natation",
    bike: "VTT",
    run: "Course à pied",
  },
  {
    key: 1,
    value: "XS",
    check: true,
    swim: "250 m",
    bike: "5,5 km",
    run: "2 km",
  },
  {
    key: 2,
    value: "S",
    check: true,
    swim: "500",
    bike: "11 km",
    run: "4 km",
  },
  {
    key: 3,
    value: "M",
    check: true,
    swim: "1000",
    bike: "22 km",
    run: "8 km",
  },
  {
    key: 4,
    value: "L",
    check: true,
    swim: "2000 m",
    bike: "44 km",
    run: "16 km",
  },
  {
    key: 5,
    value: "XL",
    check: true,
    swim: "3000 m",
    bike: "66 km",
    run: "24 km",
  },
];

export default distanceNature;
